export default {
  multipleEmails: 'Invalid email',
  email: 'Enter a valid email',
  sameAs: 'Doesn’t Match',
  minLength: 'At least %v characters',
  maxLength: '%v characters maximum',
  exactLength: 'Exactly %v digits required',
  required: 'This field is required',
  alphaNum: 'Only letters and numbers are allowed',
  hasOneLower: 'At least one lowercase letter',
  hasOneUpper: 'At least one uppercase letter',
  hasOneDigit: 'At least one number',
  validateIsAdult: 'You must be at least 18 years old',
  alpha: 'Only letters are allowed',
  onlyCharacters: 'Only letters are allowed',
  validateUSZipCode: 'Enter a valid code',
  validateCardNumber: '',
  validateSSN: '4 digits are required',
  numeric: 'Numbers only',
  price: 'Invalid amount',
  between: 'Amount must be between $%v1 and $%v2',
  minValue: 'Minimum amount is $%v',
  minLengthDigit: 'Min. %v digits',
  maxLengthDigit: 'Max. %v digits',
  minValueDeposit: 'Minimum amount is $%v',
  maxValueDeposit: 'Maximum amount is $%v',
  usernameIsValid: 'Enter a valid username',
  greaterThan: 'Value must be greater than %v',
  noSpaces: 'No spaces',
  phone: 'Enter a valid phone number',
  phoneOptional: 'Enter a valid phone number',
};



// WEBPACK FOOTER //
// ./src/helpers/validatorsMessages.js